import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { merge } from 'lodash';
import initialTogglesDictionary from '../../initialTogglesDictionary';
import { FeatureToggleState, nameReducer } from '../featureToggle.model';
import { REHYDRATE } from 'redux-persist';

export const initialStateFeatureToggle: FeatureToggleState =
  initialTogglesDictionary;

export const FeatureToggleSlice = createSlice({
  name: nameReducer,
  initialState: initialStateFeatureToggle,
  reducers: {
    loadFeatureToggles(state, action: PayloadAction<FeatureToggleState>) {
      return action.payload;
    },
    updateToggle(
      state,
      action: PayloadAction<{ name: string; value: string | boolean }>
    ) {
      const { name, value } = action.payload;
      state[name] = value;
    },
    updateToggles(state, action: PayloadAction<Partial<FeatureToggleState>>) {
      merge(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state) => {
      // Clear state when rehydrate
      // It means that is not saved in localstorage
      return {
        ...initialStateFeatureToggle,
      };
    });
  },
});

export const {
  actions: actionsFeatureToggle,
  reducer: reducerFeatureToggle,
  name: nameReducerFeatureToggle,
} = FeatureToggleSlice;
